<template>
  <div>
    <div class="absolute top-0 w-full rounded-lg p-3 h-full" style="background: rgba(255, 255, 255, 0.8); z-index: 100" >
      <div class="w-full md:w-1/2 bg-white rounded-lg m-auto h-full border flex flex-col">
        <div class="header p-3 h-16 flex">
          <i class="material-icons p-0 m-0 bg-successf"> search </i>
          <input
            v-model.trim="search"
            class="w-full border-0 rounded-lg h-8 px-2"
            type="text"
            :placeholder="$t(`MODALS.modalDependencias.search`)"
          />
        </div>
        <div class="body p-3 h-full bg-succdess border border-l-0 border-r-0 overflow-auto">
          <div>
            <vs-checkbox v-model="all" @change="selectedAll(all)">All</vs-checkbox>
          </div>
          <ul>
            <li class="flex py-2" v-for="(question, index) in filterQuestions" :key="index">
              <vs-checkbox v-model="checkBox1" :vs-value="question"></vs-checkbox>
              <div class="flex flex-col">
                <span class="font-bold">{{ question.name }}</span>
                <span>{{ question.label }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="footer p-3 py-4 h-24 flex justify-end">
          <vs-button color="danger" type="border" @click="$emit('update:active', false)">Cancelar</vs-button>
          <vs-button class="ml-3 mr-3" color="success" type="border" @click="addQuestion"> Aceptar </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getDependencies } from "@/serviforms/designer/indexDB/dependencies";

import { getAllQuestion } from "@/serviforms/designer/indexDB/logic.js";

export default {
  props: ["value"],
  async mounted() {
    const dependencies = await this.getAllDependencies();
    const allQuestions = await getAllQuestion();
    const filterQuestions = this.questionsDescendants(allQuestions);
    this.ListQuestions = this.matchQuestions(dependencies, filterQuestions);
  },
  data() {
    return {
      all: false,
      search: "",
      checkBox1: [],
      ListQuestions: []
    };
  },
  methods: {
    /**
     * Agrega un array de preguntas hijas para crear la dependencia en la pregunta padre.
     */
    addQuestion() {
      this.$emit("questionsSelected", this.checkBox1);
      this.$emit("update:active", false);
    },
    /**
     * Obtiene la lista de los ids (P_X) que estan relacionados a una pregunta.
     */
    async getAllDependencies() {
      const { dependencias } = await getDependencies();
      return dependencias;
    },
    /**
     * Obtiene una lista de preguntas abajo de la pregunta padre.
     * @param {array<Question>} allQuestions
     */
    questionsDescendants(allQuestions) {
      const index = allQuestions.findIndex(question => question.name === this.question.name);
      return allQuestions.slice(index + 1, allQuestions.length);
    },
    /**
     * Excluye las preguntas que ya se encuentren en un tipo de relación.
     * @param {arrray<string>} dependencies
     * @param {array<questions>} filterQuestions
     */
    matchQuestions(dependencies, filterQuestions) {
      return filterQuestions.filter(question => !dependencies.includes(question.name));
    },
    /**
     * Selecciona ó vacia toda la lista de preguntas que se relacionarán a la pregunta padre.
     * @param {array} all
     */
    selectedAll(all) {
      if (all) return (this.checkBox1 = this.ListQuestions);
      return (this.checkBox1 = []);
    }
  },
  computed: {
    ...mapState("resource", ["indexQuestion", "questionsByPage"]),
    /**
     * Obtiene la pregunta sobre la que se le aplicará la relación, esta va a ser la pregunta padre.
     */
    question() {
      return this.questionsByPage[this.indexQuestion];
    },
    /**
     * Filtra la lista de preguntas hijas por busqueda del id ó de la etiqueta de la pregunta.
     */
    filterQuestions() {
      return this.ListQuestions.filter(question => {
        if (this.search.length > 0) {
          const name = question.name.toLowerCase().includes(this.search.toLowerCase());
          const label = question.label.toLowerCase().includes(this.search.toLowerCase());
          return name || label;
        }
        return true;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
